import { CartAddEvent } from '@theme/events';
import { fetchConfig } from '@theme/utilities';

if (!window.__BZ_HOME_V2__) {
  window.__BZ_HOME_V2__ = true;

  const warmDeferredImages = () => {
    const bestsellerImage = document.querySelector('.bzv2-best__visual img');
    const flavorImages = Array.from(document.querySelectorAll('.bz-flavor-deck__art')).slice(0, 4);
    [bestsellerImage, ...flavorImages].filter(Boolean).forEach((image) => {
      image.loading = 'eager';
      image.fetchPriority = 'auto';
      if (!image.complete) image.decode().catch(() => {});
    });
  };

  const queueDeferredImages = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warmDeferredImages, { timeout: 800 });
    } else {
      window.setTimeout(warmDeferredImages, 0);
    }
  };

  if (document.readyState === 'complete') queueDeferredImages();
  else window.addEventListener('load', queueDeferredImages, { once: true });

  document.addEventListener('click', async (event) => {
    const option = event.target.closest('[data-bz-pack-selector] [data-qty][data-total]');
    if (option) {
      const root = option.closest('[data-bz-pack-selector]');
      root.querySelectorAll('[data-qty]').forEach((el) => el.classList.toggle('is-active', el === option));
      const add = root.querySelector('[data-bz-v2-add]');
      if (add) {
        add.dataset.qty = option.dataset.qty || '1';
        const total = root.querySelector('[data-bz-total]');
        if (total) total.textContent = option.dataset.total || '';
      }
      return;
    }

    const button = event.target.closest('[data-bz-v2-add]');
    if (!button || button.dataset.loading === 'true') return;

    const variantId = button.dataset.variantId;
    const productId = button.dataset.productId || '';
    const quantity = Math.max(1, parseInt(button.dataset.qty || '1', 10));
    if (!variantId) return;

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((element) => element.dataset.sectionId)
      .filter(Boolean);

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', String(quantity));
    if (sectionIds.length) formData.append('sections', sectionIds.join(','));
    formData.append('sections_url', window.location.pathname);

    const original = button.innerHTML;
    button.dataset.loading = 'true';
    button.textContent = 'Ekleniyor…';

    try {
      const cfg = fetchConfig('javascript', { body: formData });
      const response = await fetch('/cart/add.js', {
        ...cfg,
        headers: { ...cfg.headers, Accept: 'text/html' },
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || data.message || 'Sepete eklenemedi.');

      document.dispatchEvent(
        new CartAddEvent(data, variantId, {
          source: 'bz-home-v2',
          itemCount: quantity,
          productId,
          variantId,
          sections: data.sections || {},
        })
      );

      button.textContent = 'Sepete Eklendi ✓';
      window.setTimeout(() => {
        button.innerHTML = original;
        button.dataset.loading = 'false';
      }, 1200);
    } catch (error) {
      console.error(error);
      button.textContent = 'Tekrar Dene';
      button.dataset.loading = 'false';
    }
  });

  const mobileBuybar = document.querySelector('[data-bz-mobile-buybar]');
  const hero = document.querySelector('.bzv2-hero');
  const buybarStop = document.querySelector('.bzv2-final, footer');

  if (mobileBuybar && hero && 'IntersectionObserver' in window) {
    let heroVisible = true;
    let stopVisible = false;

    const syncMobileBuybar = () => {
      const visible = !heroVisible && !stopVisible;
      mobileBuybar.classList.toggle('is-visible', visible);
      mobileBuybar.setAttribute('aria-hidden', String(!visible));
    };

    new IntersectionObserver(([entry]) => {
      heroVisible = entry.isIntersecting;
      syncMobileBuybar();
    }).observe(hero);

    if (buybarStop) {
      new IntersectionObserver(([entry]) => {
        stopVisible = entry.isIntersecting;
        syncMobileBuybar();
      }, { rootMargin: '0px 0px 80px' }).observe(buybarStop);
    }
  }

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.animate(
            [{ opacity: 0, transform: 'translateY(18px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 650, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'both' }
          );
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-bz-reveal]').forEach((el) => observer.observe(el));
  }
}

